module.exports = __webpack_public_path__ + "media/post-listing-block-4-overlay.c6444b37.png";